import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** New page, top of the page — except when the browser is restoring a position. */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname]);

  return null;
}
